module.exports = __webpack_public_path__ + "media/images/emblems/GW-NE-Val-de-Travers-60dd6c06daf455a169e6452fa84925c8.png";